import instance from './instance';

export const getMeetingTimeData = ({ dateRange }) => instance.get(`/dashboards/meeting_time?dateRange=${dateRange}`);

export const getManagerDashboard = ({ dateRange }) =>
  instance.get(`/dashboards/manager_dashboard?dateRange=${dateRange}`);

export const getManagerDashboardTableData = ({ dateRange }) =>
  instance.get(`/dashboards/manager_dashboard_table_data?dateRange=${dateRange}`);

export const getExecutiveDashboard = ({ dateRange, metric, grouping }) =>
  instance.get(`/dashboards/executive_dashboard?dateRange=${dateRange}&metric=${metric}&groupby=${grouping}`);

export const getExecutiveDashboardV2 = ({ dateRange, chart, department }) =>
  instance.get(`/dashboards/executive_dashboard_v2?dateRange=${dateRange}&chart=${chart}&department=${department}`);
